var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("small", [
      _vm._v(
        "\n    " +
          _vm._s(_vm._f("translate")("Already have an account?")) +
          "\n    "
      ),
      _c(
        "a",
        {
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.openModal.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n      " + _vm._s(_vm._f("translate")("Sign in")) + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "modal",
        staticClass: "modal fade",
        attrs: {
          tabindex: "-1",
          "aria-labelledby": "loginModal",
          "aria-hidden": "true",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content login-modal-content" }, [
            _c("button", {
              staticClass: "btn-close login-modal-close",
              attrs: {
                type: "button",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
              },
            }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body px-4 pt-2 pb-4" }, [
              _c("h5", { staticClass: "text-center fw-bold mb-1" }, [
                _vm._v(_vm._s(_vm._f("translate")("Sign in"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-center text-muted small mb-4" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("translate")(
                      "Welcome back! Please sign in to continue."
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-3" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "form-label small fw-semibold",
                      attrs: { for: "inputEmail" },
                    },
                    [_vm._v(_vm._s(_vm._f("translate")("Email")))]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email",
                      },
                    ],
                    staticClass: "form-control login-input",
                    class: { "is-invalid": "email" in _vm.errors },
                    attrs: {
                      type: "email",
                      id: "inputEmail",
                      placeholder: _vm._f("translate")("your@email.com"),
                      required: "",
                      autofocus: "",
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.email = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("InputErrors", {
                    attrs: { name: "email", errors: _vm.errors },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "form-label small fw-semibold",
                      attrs: { for: "inputPassword" },
                    },
                    [_vm._v(_vm._s(_vm._f("translate")("Password")))]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "form-control login-input",
                    class: { "is-invalid": "password" in _vm.errors },
                    attrs: {
                      type: "password",
                      id: "inputPassword",
                      required: "",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.password = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("InputErrors", {
                    attrs: { name: "password", errors: _vm.errors },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-end mb-4" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-muted small login-forgot-link",
                    attrs: { href: "/password/reset" },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm._f("translate")("Forgot Your Password?")) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-dark w-100 login-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.login.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("translate")("Sign in")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-center mt-3" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-link btn-sm text-muted login-cancel-link",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.hideModal.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm._f("translate")("Cancel")) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "login-modal-icon" }, [
      _c("i", { staticClass: "fas fa-user" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }